import { MoonIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import type { Locales } from "~/i18n/i18n-types";
import { RTL_LOCALES } from "~/utils/constants";
import { useLocale } from "~/utils/use-locale";
import { Switch } from "../ui/switch";

const DarkModeBtn = () => {
	const { setTheme, theme } = useTheme();

	const handleThemeChange = (bool: boolean) => {
		setTheme(bool ? "dark" : "light");
	};

	const locale = useLocale() as Locales;
	const isRtl = RTL_LOCALES.includes(locale);

	return (
		<Switch
			aria-label="dark mode"
			checked={theme === "dark"}
			dir={isRtl ? "rtl" : "ltr"}
			disabled={theme === "contrast"}
			onCheckedChange={handleThemeChange}
			title={theme === "dark" ? "switch to light mode" : "switch to dark mode"}
		>
			{theme === "dark" ? (
				<MoonIcon role="presentation" size={14} />
			) : (
				<SunIcon role="presentation" size={14} />
			)}
		</Switch>
	);
};

export default DarkModeBtn;
